"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var DoubleFront_exports = {};
__export(DoubleFront_exports, {
  default: () => DoubleFront_default
});
module.exports = __toCommonJS(DoubleFront_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.9258 4.66406L16.9258 9.66406C17.082 9.82031 17.1602 10.0156 17.1602 10.25C17.1602 10.4844 17.082 10.6797 16.9258 10.8359L11.9258 15.8359C11.7565 16.0052 11.5547 16.0898 11.3203 16.0898C11.099 16.0898 10.9036 16.0052 10.7344 15.8359C10.5781 15.6797 10.5 15.4844 10.5 15.25C10.5 15.0156 10.5781 14.8203 10.7344 14.6641L15.1484 10.25L10.7344 5.83594C10.5781 5.67969 10.5 5.48438 10.5 5.25C10.5 5.01562 10.5781 4.82031 10.7344 4.66406C10.9036 4.49479 11.099 4.41016 11.3203 4.41016C11.5547 4.41016 11.7565 4.49479 11.9258 4.66406ZM5.26562 4.66406L10.2656 9.66406C10.4219 9.82031 10.5 10.0156 10.5 10.25C10.5 10.4844 10.4219 10.6797 10.2656 10.8359L5.26562 15.8359C5.09635 16.0052 4.89453 16.0898 4.66016 16.0898C4.4388 16.0898 4.24349 16.0052 4.07422 15.8359C3.91797 15.6797 3.83984 15.4844 3.83984 15.25C3.83984 15.0156 3.91797 14.8203 4.07422 14.6641L8.48828 10.25L4.07422 5.83594C3.91797 5.67969 3.83984 5.48438 3.83984 5.25C3.83984 5.01562 3.91797 4.82031 4.07422 4.66406C4.24349 4.49479 4.4388 4.41016 4.66016 4.41016C4.89453 4.41016 5.09635 4.49479 5.26562 4.66406Z",
      fill: "currentColor"
    }
  )
);
const SvgDoubleFront = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var DoubleFront_default = SvgDoubleFront;
